/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedItemTrackingProvider_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedItemTrackingProvider_viewer";
};
export type SbSharedItemTrackingProvider_viewer$data = SbSharedItemTrackingProvider_viewer;
export type SbSharedItemTrackingProvider_viewer$key = {
    readonly " $data"?: SbSharedItemTrackingProvider_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedItemTrackingProvider_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedItemTrackingProvider_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "regionsByZipCode",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '8f6b57b3c8e071c3e629c5e09591e0ac';
export default node;
